import { clsx } from 'clsx'
import { useLatestCallback } from 'hook/useLatestCallback'
import { MouseEvent, ReactNode } from 'react'

import { getPaddingStyle, Padding, styles } from 'util/style'
import css from './Link.module.scss'

interface Props {
  action?(): unknown
  children?: ReactNode
  className?: string
  disabled?: boolean
  href?: string
  pad?: Padding
  path?: string
  secondary?: boolean
  small?: boolean
  wide?: boolean
  wrap?: boolean
}

export const Link = (all: Props) => {
  const { action, children, href, path, secondary, small, wide, wrap, ...props } = all

  const pad = getPaddingStyle(props.pad)
  const style = styles(pad)

  const link = href ?? path ?? ''
  const target = href ? '_blank' : undefined
  const rel = href ? 'noopener' : undefined
  const disabled = props.disabled || !link

  const className = clsx(props.className, css.link, disabled && css.disabled, secondary && css.secondary,
    small && css.small, wide && css.wide, wrap && css.wrap)

  const onClick = useLatestCallback((event: MouseEvent) => {
    if (disabled) return

    const { metaKey, ctrlKey, altKey, shiftKey } = event
    const meta = Boolean(metaKey || ctrlKey || altKey || shiftKey)
    if (meta) return

    if (action) {
      event.preventDefault()
      action()
    } else if (path) {
      event.preventDefault()
      location.assign(path)
    }
  })

  return <a className={className} style={style} href={link} target={target} rel={rel} onClick={onClick}>
    {children}
  </a>
}
